import { useFakedUID } from "./useFakeUID";
import useFirebaseData from "./useFirebaseData";
import type { FirebaseRecord, InventoryItem } from "../types";

const useFirebaseInventory = () => {
  const uid = useFakedUID();
  return useFirebaseData<FirebaseRecord<InventoryItem>>(uid ? `/userdata/${uid}/inventory` : null);
};

export default useFirebaseInventory;
